<template>
  <footer class="legal-footer" role="contentinfo" aria-label="Liens legaux">
    <div class="legal-footer-inner">
      <span class="legal-brand">MemoFast</span>
      <nav class="legal-links" aria-label="Documents legaux">
        <router-link to="/plans">Formules</router-link>
        <span class="sep" aria-hidden="true">·</span>
        <router-link to="/cgu">CGU</router-link>
        <span class="sep" aria-hidden="true">·</span>
        <router-link to="/confidentialite">Confidentialite</router-link>
        <span class="sep" aria-hidden="true">·</span>
        <router-link to="/mentions-legales">Mentions legales</router-link>
        <span class="sep" aria-hidden="true">·</span>
        <router-link to="/cookies">Cookies</router-link>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'LegalFooter'
}
</script>

<style scoped>
.legal-footer {
  width: 100%;
  padding: var(--space-base) 0;
  border-top: 1px solid var(--color-border-light);
  background: var(--color-surface);
}

.legal-footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 var(--space-base);
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
  align-items: center;
  justify-content: space-between;
}

.legal-brand {
  font-family: var(--font-family-logo);
  color: var(--color-primary);
  font-weight: 700;
}

.legal-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  font-weight: 700;
}

.legal-links a {
  color: var(--color-primary);
  text-decoration: none;
}

.legal-links a:hover {
  text-decoration: underline;
}

.sep {
  color: var(--color-text-tertiary);
  font-weight: 600;
}
</style>
